module.exports = __webpack_public_path__ + "static/img/ad.d4227482.svg";